module.exports = "video {\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/base-video/base-video.component.css
// module id = ./src/app/commons/base-video/base-video.component.css
// module chunks = main